module.exports = __webpack_public_path__ + "static/mAdapt-team-3f6a82d75372ed32b83fc4e2fb986fe8.jpg";